import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { DataProvider } from '../data/data';
import { AlertProvider } from '../alert/alert';
import { TranslateService } from '@ngx-translate/core';
import { ProductProvider } from '../product/product';
import { Product } from '../../models/product';

@Injectable()
export class ScanProvider {

  constructor(private barcodeScanner: BarcodeScanner,
              private alert: AlertProvider,
              private translate: TranslateService,
              private productProvider: ProductProvider) {
                
                
  }

  /**
  * Opens barcode scanner, and executes handler passing the id of the product
  * that was scanned.
  */
  public findProduct(handler: (item: Product) => void) {
    var options = {
      preferFrontCamera: false, // iOS and Android
      showFlipCameraButton: false, // iOS and Android
      showTorchButton: false, // iOS and Android
      torchOn: false, // Android, launch with the torch switched on (if available)
      prompt: this.translate.instant('BARCODE.SCAN_MESSAGE'), // Android
      resultDisplayDuration: 0, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
      //formats: "EAN_8,EAN_13", // default: all but PDF_417 and RSS_EXPANDED
      orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
      disableAnimations: false, // iOS
      disableSuccessBeep: true // iOS and Android
    };

    this.barcodeScanner.scan(options).then(async (result) => {
      if(result.cancelled) return;
      // Get products with result
      var p = await this.productProvider.getProducts({ barcode: result.text });
      if (p.length > 0) {
        handler(p[0]);
      } else {
        // Product not available
        this.alert.simple('BARCODE.NOT_FOUND_TITLE', 'BARCODE.NOT_FOUND_MESSAGE');
      }
    }).catch((error) => {
      // Something went wrong
      this.alert.error(error);
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/scan/scan.ts